<template lang="html">
  <v-page :profile="profile">
    <ProfileModal
      :show="showProfileModal"
      :vibbranteData="vibbranteData"
      @close="showProfileModal = false"
      @save="onProfileModalSave"
    />
    <div v-if="showHolidayModal" class="holiday-modal" style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.5); z-index: 9999; display: flex; justify-content: center; align-items: center;">
      <div style="background: white; padding: 30px; border-radius: 10px; max-width: 500px; text-align: center;">
        <h2>Olá!</h2>
        <p>💰 Pagamentos na Vibbra:</p>
        <p>✅ Processamento das solicitações de resgate feitas até 19/06, serão realizados em 20/06.</p>
        <v-button @click="closeHolidayModal" class="mt-3">Fechar</v-button>
      </div>
    </div>
    <v-topbar :profile="profile" />
    <v-breadcrumb :steps="[{ label: 'Clientes' }]" />

    <v-container>
      <v-tabs id="user-list-tabs" class="mb-3 nav-pills">
        <v-button
          href="#active"
          @click="clickTabButton('active')"
          :class="showTabButton('active')"
          >Ativos</v-button
        >
        <v-button
          href="#pending"
          @click="clickTabButton('pending')"
          :class="showTabButton('pending')"
          >Pendentes</v-button
        >
        <v-button
          href="#finalized"
          @click="clickTabButton('closed')"
          :class="showTabButton('finalized')"
          >Finalizados</v-button
        >
      </v-tabs>
      <v-div class="tab-content">
        <v-content
          class="tab-pane"
          :class="showTabContent('active')"
          id="active"
          role="tabpanel"
        >
          <v-row>
            <v-col md="12">
              <v-div class="user-items">
                <v-row class="size-2">
                  <v-alert v-if="activesContracts.length === 0" close>
                    <strong
                      >Você não possui Clientes com contratos ativos</strong
                    ><br />
                    Quando for contratado, eles irão aparecer aqui para que
                    possa reportar as suas horas trabalhadas.
                  </v-alert>
                  <v-col
                    :xs="12"
                    :md="6"
                    :lg="6"
                    v-for="contract in activesContracts"
                  >
                    <v-card class="mb-0 p-3 card-user contract-card">
                      <v-avatar
                        @click="showClientModal(contract.client)"
                        :name="
                          contract.client.name + ' ' + contract.client.lastname
                        "
                        :about="
                          contract.client.city + ' ' + contract.client.state
                        "
                        class="mb-3"
                        :image="contract.client.avatar"
                      >
                      </v-avatar>

                      <!-- Ícone de contrato renovado -->
                      <div
                        v-if="contract.parent_contract_id"
                        class="renewal-badge"
                        @click="openParentContract(contract.parent_contract_id)"
                        title="Contrato renovado - Clique para ver o contrato anterior"
                      >
                        <span class="renewal-arrow">🔄</span>
                        <span class="renewal-text">Contrato Renovado</span>
                      </div>

                      <div v-if="contract.last_tasks.length === 0">
                        <v-divider line class="mb-2"
                          >Nenhuma tarefa registrada</v-divider
                        >
                      </div>
                      <div v-else>
                        <v-divider line class="mb-2">Últimas tarefas</v-divider>
                        <v-list class="user-profile">
                          <v-text
                            v-for="task in contract.last_tasks"
                            :key="n"
                            tag="div"
                          >
                            {{ task.task_date | moment('DD/MM/YYYY') }} -
                            {{ task.duration }}h - {{ task.description }}
                          </v-text>
                        </v-list>
                      </div>

                      <v-button
                        class="block primary mt-3"
                        :size="2"
                        @click="goToTasks(contract.client.name, contract.id)"
                      >
                        Acompanhamento
                      </v-button>
                      <small
                        slot="top-left"
                        class="badge badge-danger"
                        v-if="contract.release_hours === 0"
                        >{{ contract.release_hours }}h liberadas</small
                      >
                      <small slot="top-left" class="text-muted" v-else
                        >{{ contract.release_hours }}h liberadas</small
                      >
                      <small slot="top-right" class="text-muted"
                        >{{ contract.work_hours }}h trabalhadas</small
                      >
                    </v-card>
                  </v-col>
                </v-row>
              </v-div>
            </v-col>
          </v-row>
        </v-content>
        <v-content
          class="tab-pane"
          :class="showTabContent('pending')"
          id="pending"
          role="tabpanel"
        >
          <v-row>
            <v-col md="12">
              <v-div class="user-items">
                <v-row class="size-2">
                  <v-alert v-if="pendingContracts.length === 0" close>
                    <strong
                      >Você não possui Clientes em processo de
                      contratação</strong
                    ><br />
                    Aqui irão aparecer aqueles Clientes que selecionaram o seu
                    perfil e estão querendo contratá-lo.
                  </v-alert>
                  <v-col
                    :xs="12"
                    :md="12"
                    :lg="4"
                    v-for="contract in pendingContracts"
                  >
                    <v-card class="mb-0 p-3 card-user contract-card">
                      <v-avatar
                        @click="showClientModal(contract.client)"
                        :name="contract.client.name"
                        :about="
                          contract.client.city + ' ' + contract.client.state
                        "
                        class="mb-3"
                        :image="contract.client.avatar"
                      >
                      </v-avatar>

                      <!-- Ícone de contrato renovado -->
                      <div
                        v-if="contract.parent_contract_id"
                        class="renewal-badge"
                        @click="openParentContract(contract.parent_contract_id)"
                        title="Contrato renovado - Clique para ver o contrato anterior"
                      >
                        <span class="renewal-arrow">🔄</span>
                        <span class="renewal-text">Contrato Renovado</span>
                      </div>
                        <small
                          class="badge badge-primary"
                          v-if="
                            contract.status === 'waiting_answer_from_vibbrante'
                          "
                          >{{
                            getStatusDescription(
                              contract.status,
                              contract.release_reject_message
                            )
                          }}</small
                        >
                        <small
                          class="badge badge-info"
                          v-if="
                            contract.status ===
                              'waiting_confirmation_from_client'
                          "
                          >{{
                            getStatusDescription(
                              contract.status,
                              contract.release_reject_message
                            )
                          }}</small
                        >
                        <small
                          class="badge badge-danger"
                          v-if="
                            contract.status === 'reject_by_client' &&
                              contract.release_reject_message
                          "
                          >{{
                            getStatusDescription(
                              contract.status,
                              contract.release_reject_message
                            )
                          }}</small
                        >
                        <small
                          class="badge badge-secondary"
                          v-if="
                            contract.status === 'reject_by_client' &&
                              !contract.release_reject_message
                          "
                          >{{
                            getStatusDescription(
                              contract.status,
                              contract.release_reject_message
                            )
                          }}</small
                        >
                        <small
                          class="badge badge-warning"
                          v-if="contract.status === 'waiting_credit'"
                          >{{
                            getStatusDescription(
                              contract.status,
                              contract.release_reject_message
                            )
                          }}</small
                        >
                      </v-avatar>
                      <v-list class="user-profile mt-3">
                        <v-text tag="div"
                          >Quantidade de horas desejadas:
                          <span v-if="contract.expect_hours === 1"
                            >{{ contract.expect_hours }} hora</span
                          >
                          <span v-else>{{ contract.expect_hours }} horas </span>
                        </v-text>
                        <v-text tag="div"
                          >Início previsto:
                          <span>
                            {{
                              contract.expected_start_date
                                | moment('DD/MM/YYYY')
                            }}
                          </span>
                        </v-text>
                        <v-text tag="div"
                          >Valor/hora:
                          <span
                            v-if="
                              contract.status ===
                                'waiting_confirmation_from_client' ||
                                contract.status === 'waiting_credit'
                            "
                          >
                            <span
                              v-if="
                                contract.hour_value_vibbrante !=
                                  contract.expected_hour_value_vibbrante
                              "
                              :title="
                                ('desconto ' +
                                  calcDiscount(
                                    contract.hour_value_vibbrante,
                                    contract.expected_hour_value_vibbrante
                                  ))
                                  | currency
                              "
                            >
                              <small
                                ><s>{{
                                  contract.expected_hour_value_vibbrante
                                    | currency
                                }}</s></small
                              >
                              {{ contract.hour_value_vibbrante | currency }}
                            </span>
                            <span v-else>
                              {{ contract.hour_value_vibbrante | currency }}
                            </span>
                          </span>
                          <span v-else>{{
                            contract.expected_hour_value_vibbrante | currency
                          }}</span>
                        </v-text>
                        <v-text tag="div"
                          >Horas semanais:
                          <span> {{ contract.hour_available }} horas </span>
                        </v-text>
                        <v-text tag="div" class="dont-break-out">
                          {{ contract.description }}
                        </v-text>
                      </v-list>
                      <v-row :size="1">
                        <v-col :xs="12" :sm="12" :md="6">
                          <v-button
                            class="block link mt-2"
                            :size="1"
                            @click="showQuestion(contract)"
                          >
                            Mensagens
                            <v-badge
                              class="mr-2 mb-2 danger"
                              size="2"
                              v-if="contract.comments_unread_from_client > 0"
                            >
                              <i class="icon icon-email"></i>
                            </v-badge>
                          </v-button>
                        </v-col>
                        <v-col :xs="12" :sm="12" :md="6">
                          <v-button
                            class="block link mt-2"
                            :size="1"
                            @click="showRejectModal(contract)"
                          >
                            <span
                              v-if="
                                contract.status ===
                                  'waiting_answer_from_vibbrante'
                              "
                              >Recusar</span
                            >
                            <span v-else>Cancelar</span>
                          </v-button>
                        </v-col>
                      </v-row>
                      <v-button
                        v-if="
                          contract.status === 'waiting_answer_from_vibbrante'
                        "
                        class="block primary mt-2"
                        :size="2"
                        @click="goToSign(contract)"
                      >
                        Assinar contrato
                      </v-button>
                      <v-button
                        v-else-if="
                          contract.status === 'reject_by_client' &&
                            contract.release_reject_message
                        "
                        class="block gray mt-2"
                        :size="2"
                        @click="
                          showJustificationModal(
                            contract,
                            contract.reject_description,
                            contract.cancellation_reason.description
                          )
                        "
                        >Ver justificativa</v-button
                      >
                      <v-button
                        v-else-if="
                          contract.status === 'reject_by_client' &&
                            !contract.release_reject_message
                        "
                        class="block gray mt-2"
                        :size="2"
                        @click=""
                        >Aguardando</v-button
                      >
                      <v-button
                        v-else-if="
                          contract.status ===
                            'waiting_confirmation_from_client' ||
                            contract.status === 'waiting_credit'
                        "
                        class="block primary mt-2"
                        :size="2"
                        @click=""
                        disabled
                        >Contrato assinado!</v-button
                      >
                    </v-card>
                  </v-col>
                </v-row>
              </v-div>
            </v-col>
          </v-row>
        </v-content>
        <v-content
          class="tab-pane"
          :class="showTabContent('finalized')"
          id="finalized"
          role="tabpanel"
        >
          <v-row>
            <v-col md="12">
              <v-div class="user-items">
                <v-row class="size-2">
                  <v-alert v-if="closedContracts.length === 0" close>
                    <strong
                      >Você não possui Clientes com contratos
                      finalizados</strong
                    ><br />
                    Aqui você poderá consultar sempre o histórico de como foi o
                    trabalho com cada um dos Clientes que o contratou.
                  </v-alert>
                  <v-col
                    :xs="12"
                    :md="6"
                    :lg="4"
                    v-for="contract in closedContracts"
                  >
                    <v-card class="mb-0 p-3 card-user contract-card">
                      <v-avatar
                        @click="showClientModal(contract.client)"
                        :name="
                          contract.client.name + ' ' + contract.client.lastname
                        "
                        :about="
                          aboutAvatar(
                            contract.client.city,
                            contract.client.state
                          )
                        "
                        class="mb-3"
                        style="margin-top: 2rem"
                        :image="contract.client.avatar"
                      >
                      </v-avatar>

                      <!-- Ícone de contrato renovado -->
                      <div
                        v-if="contract.parent_contract_id"
                        class="renewal-badge"
                        @click="openParentContract(contract.parent_contract_id)"
                        title="Contrato renovado - Clique para ver o contrato anterior"
                      >
                        <span class="renewal-arrow">🔄</span>
                        <span class="renewal-text">Contrato Renovado</span>
                      </div>

                      <v-divider line class="mb-2">
                        Finalizado em
                        {{ contract.close_date | moment('DD/MM/YYYY') }}
                      </v-divider>
                      <v-button
                        v-if="!contract.rating_client"
                        class="block primary mt-4"
                        @click="showRatingModal(contract)"
                        :size="2"
                        >Avaliar</v-button
                      >
                      <div v-else class="text-center mb-2">
                        <v-row class="size-1">
                          <v-col :xs="12" :md="6" :lg="6" class="text-right">
                            Gestão
                          </v-col>
                          <v-col :xs="12" :md="6" :lg="6">
                            <v-stars
                              class="mt-1"
                              mode="full"
                              :stars="contract.rating_management"
                            />
                          </v-col>
                        </v-row>
                        <v-row class="size-1">
                          <v-col :xs="12" :md="6" :lg="6" class="text-right">
                            Disponibilidade
                          </v-col>
                          <v-col :xs="12" :md="6" :lg="6">
                            <v-stars
                              class="mt-1"
                              mode="full"
                              :stars="contract.rating_availability"
                            />
                          </v-col>
                        </v-row>
                        <v-row class="size-1">
                          <v-col :xs="12" :md="6" :lg="6" class="text-right">
                            Trabalharia de novo
                          </v-col>
                          <v-col :xs="12" :md="6" :lg="6">
                            <v-stars
                              class="mt-1"
                              mode="full"
                              :stars="contract.rating_interest_new_job"
                            />
                          </v-col>
                        </v-row>
                      </div>
                      <v-button
                        class="block gray mt-2"
                        :size="2"
                        @click="goToTasks(contract.client.name, contract.id)"
                        >Ver histórico</v-button
                      >
                      <small slot="top-right" class="text-muted"
                        >{{ contract.work_hours }}h trabalhadas</small
                      >
                    </v-card>
                  </v-col>
                </v-row>
                <pagination
                  :totalPages="closedContractsPaginate.totalPages"
                  :loadPage="loadClosedContracts"
                ></pagination>
              </v-div>
            </v-col>
          </v-row>
        </v-content>
      </v-div>
    </v-container>

    <!-- MODALS -->
    <div
      v-if="showUpdateHoursModal"
      class="custom-modal-overlay"
    >
      <div class="custom-modal">
        <div class="custom-modal-header">
          <h4>Atualize suas horas</h4>
          <button @click="closeUpdateHoursModal" class="close-btn">&times;</button>
        </div>
        <div class="custom-modal-body">
          <div class="row">
            <div class="col-md-5">
              <img src="@/assets/photoPeople/Sarah-designer.png" class="img-fluid" alt="Update hours" />
            </div>
            <div class="col-md-7">
              <h4>Manter sua disponibilidade de horas atualizada aumenta suas chances de contratação! Certifique-se de ajustar conforme sua agenda.</h4>

              <div class="form-group mt-4">
                <label>Horas semanais disponíveis:</label>
                <input
                  type="number"
                  class="form-control"
                  v-model="userAvailableHours"
                  min="0"
                  max="168"
                />
              </div>

              <div class="text-right mt-4">
                <v-button class="primary" @click="saveHours">
                  Salvar
                </v-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <v-modals
      name="client"
      :show="client_modal_show"
      :data="{ user: selected_client }"
      @onHide="client_modal_show = false"
    />
    <v-modals
      name="user-justification"
      :show="user_justification_modal_show"
      title="Motivo do cancelamento"
      profile="vibbrante"
      :data="{
        text: justification_text,
        contract: selected_contract,
        cancellation_reason: cancellation_reason,
      }"
      @onHide="user_justification_modal_show = false"
    />
    <v-modals
      name="finalized"
      :show="finalized_modal_show"
      @onHide="finalized_modal_show = false"
      :data="{}"
    />
    <v-modals
      name="alert"
      :show="alert_modal_show"
      @onHide="alert_modal_show = false"
      :data="{ message: alert_msg, destiny: 'vibbrant-profile' }"
    />
    <v-modals
      name="contract-finalize"
      :show="contract_finalize_modal_show"
      :data="{ contract: selected_contract, client_name: client_name }"
      @onHide="contract_finalize_modal_show = false"
    />
    <v-modals
      name="user-question"
      title="Tire suas dúvidas com o contratante"
      :show="user_question_modal_show"
      :data="{
        comments: comments,
        contract_id: selected_contract.id,
        comment_from: 'vibbrante',
      }"
      @onHide="user_question_modal_show = false"
    />
    <v-cancel-contract
      name="vibbrante-cancel-contract"
      :title="rejectModalTitle"
      :show="client_cancel_contract_modal_show"
      :data="{ contract: selected_contract }"
      @onHide="client_cancel_contract_modal_show = false"
    />
    <RatingNpsCsatVibbra />
    <v-announcement-modal
      v-if="showAnnouncementModal"
      :show="showAnnouncementModal"
      ref="announcementModal"
      @onHide="hideAnnouncementModal"
    />
  </v-page>
</template>

<script>
import apiVibbrante from '@/api/vibbrante';
import vibbranteApi from '@/api/vibbrante';
import RatingNpsCsatVibbra from '@/parts/components/rating-nps-csat-vibbra';
import CancelContractModal from '@/parts/modals/vibbrante-cancel-contract';
import Pagination from '@/parts/components/pagination';
import AnnouncementModal from '@/parts/modals/announcement-modal';
import ProfileModal from '@/parts/components/profile-modal.vue';

export default {
  props: {
    profile: String,
    activeTab: {
      type: String,
      default: 'active',
    },
  },
  components: {
    'v-cancel-contract': CancelContractModal,
    pagination: Pagination,
    RatingNpsCsatVibbra,
    'v-announcement-modal': AnnouncementModal,
    ProfileModal,
  },
  data() {
    return {
      showProfileModal: false,
      showUpdateHoursModal: false,
      showHolidayModal: this.shouldShowHolidayModal(),
      vibbranteData: {},
      currentYear: new Date().getFullYear(),
      closedContractsPaginate: {
        totalPages: 0,
      },
      justification_text: '',
      cancellation_reason: '',
      teste_model: 'texto de teste!',
      teste_model_number: 3,
      teste_model_range: [9, 11],
      teste_model_date: '',
      teste_model_checkbox: true,
      teste_model_select: 4,
      teste_model_select_options: [1, 2, 3, 4, 5, 6],

      client_modal_show: false,
      user_justification_modal_show: false,
      finalized_modal_show: false,
      contract_finalize_modal_show: false,
      user_question_modal_show: false,
      client_cancel_contract_modal_show: false,
      selected_contract: {},
      selected_client: {},
      comments: [],
      alert_modal_show: false,
      alert_msg: '',
      client_name: '',
      showAnnouncementModal: false,
      userAvailableHours: 0,
    };
  },
  mounted() {
    this.loadVibbranteNotification();
    this.loadVibbranteBalances();

    // Fetch available hours and determine modal visibility
    vibbranteApi.getVibbranteData()
      .then(response => {
        this.vibbranteData = response.data;
        this.userAvailableHours = response.data.hour_available || 40;

        // Check if modal should be open
        const lastUpdated = response.data.last_time_updated;
        const threeMonthsAgo = new Date();
        threeMonthsAgo.setMonth(threeMonthsAgo.getMonth() - 3);

        // Se last_time_updated for vazio, abrir modal de perfil profissional
        // Caso contrário, verificar se precisa atualizar horas (3 meses)
        if (!lastUpdated) {
          this.showProfileModal = true;
          this.showUpdateHoursModal = false;
        } else if (new Date(lastUpdated) < threeMonthsAgo) {
          this.showUpdateHoursModal = true;
          this.showProfileModal = false;
        }
      })
      .catch(error => {
        console.error('Error fetching vibbrante data:', error);
        this.userAvailableHours = 40;
        // Em caso de erro, também mostrar modal de perfil
        this.showProfileModal = true;
        this.showUpdateHoursModal = false;
      });

    const fullPath = this.$route.fullPath;
    const currentTab = fullPath.split('/')[fullPath.split('/').length - 1];
    this.loadContractBasedOnTab(
      ['active', 'pending', 'finalized'].includes(currentTab)
        ? currentTab
        : 'active'
    );
  },
  methods: {
    openParentContract(parentContractId) {
      // Buscar o contrato pai na API para obter o nome do cliente
      console.log('Abrindo contrato pai com ID:', parentContractId);

      vibbranteApi.vibbranteGetContract(parentContractId)
        .then(response => {
          const parentContract = response.data;
          const clientName = (parentContract.client && parentContract.client.name) || 'Cliente';
          
          // Usar a mesma função de navegação do botão "Acompanhamento"
          this.goToTasks(clientName, parentContractId);
        })
        .catch(error => {
          console.error('Erro ao buscar contrato pai:', error);
          this.$notify('Não foi possível carregar os dados do contrato pai', 'error');
        });
    },
    onProfileModalSave(data) {
      console.log('Dados recebidos da modal:', data);
      console.log('Focus recebido:', data.focus);

      // Buscar os dados completos do vibbrante antes de atualizar
      vibbranteApi.getVibbranteData()
        .then(response => {
          // Criar uma cópia dos dados atuais
          const vibbranteData = { ...response.data };

          console.log('Dados atuais do vibbrante:', vibbranteData);
          console.log('Focus atual:', vibbranteData.focus);

          // Atualizar os campos do perfil profissional com os nomes corretos do backend
          vibbranteData.profile = data.profile;
          vibbranteData.focus = data.focus;
          vibbranteData.hour_available = data.availability;

          console.log('Focus após atualização:', vibbranteData.focus);

          // Converter sinceYear em years_experience
          if (data.sinceYear) {
            vibbranteData.years_experience = this.currentYear - data.sinceYear;
          }

          vibbranteData.real_hour_value = data.hourRate;
          vibbranteData.last_time_updated = new Date().toISOString();

          console.log('Dados finais a enviar:', {
            profile: vibbranteData.profile,
            focus: vibbranteData.focus
          });

          console.log('Objeto completo sendo enviado:', vibbranteData);
          // Garantir que o focus seja enviado corretamente
          // Criar um novo objeto limpo com os dados corretos
          const dataToSend = {
            ...vibbranteData,
            profile: data.profile,  // Forçar o novo valor
            focus: data.focus        // Forçar o novo valor
          };

          // Salvar o perfil atualizado - enviar todos os dados para garantir integridade
          return vibbranteApi.updateProfile(dataToSend);
        })
        .then(() => {
          this.$notify('Perfil atualizado com sucesso!', 'success');
          this.showProfileModal = false;
          // Recarregar os dados do vibbrante
          this.loadVibbranteBalances();
          // Atualizar dados locais
          this.vibbranteData.profile = data.profile;
          this.vibbranteData.focus = data.focus;
          this.vibbranteData.hour_available = data.availability;
          this.vibbranteData.real_hour_value = data.hourRate;
          if (data.sinceYear) {
            this.vibbranteData.years_experience = this.currentYear - data.sinceYear;
          }
          this.vibbranteData.last_time_updated = new Date().toISOString();
        })
        .catch(error => {
          console.error('Erro ao atualizar perfil:', error);
          console.error('Resposta do erro:', error.response);
          if (error.response && error.response.data) {
            console.error('Dados do erro:', error.response.data);
            this.$notify(error.response.data.message || 'Erro ao atualizar o perfil', 'error');
          } else {
            this.$notify('Erro ao atualizar o perfil', 'error');
          }
        });
    },
    shouldShowHolidayModal() {
      const today = new Date();
      console.log({year: today.getFullYear(), month: today.getMonth(), day: today.getDate()})
      return (
        today.getFullYear() === 2025 &&
        today.getMonth() === 5 && // May is month 4 (0-indexed)
        today.getDate() >= 16 &&
        today.getDate() <= 20
      );
    },
    closeHolidayModal() {
      this.showHolidayModal = false;
      localStorage.setItem('holidayModalDismissed_2025_06', 'true');
    },
    aboutAvatar(city, state) {
      if (!city || state) {
        return '';
      }

      return city + ' ' + state;
    },

    showRatingModal(contract) {
      this.contract_finalize_modal_show = true;
      this.selected_contract = contract;
      this.client_name = contract.client.name;
    },
    getStatusDescription(status, release_reject_message) {
      if (status === 'waiting_answer_from_vibbrante') {
        return 'Aguardando assinatura do profissional';
      } else if (status === 'reject_by_client' && release_reject_message) {
        return 'Pedido cancelado';
      } else if (status === 'reject_by_client' && !release_reject_message) {
        return 'Em revisão pela Vibbra';
      } else if (status === 'waiting_credit') {
        return 'Aguardando compra de créditos';
      }
      return 'Aguardando assinatura do contratante';
    },
    getStatusClass(status, release_reject_message) {
      if (status === 'waiting_answer_from_vibbrante') {
        return 'success';
      } else if (status === 'reject_by_client' && release_reject_message) {
        return 'secondary';
      }
      return 'warning';
    },
    showClientModal(client) {
      // this.client_modal_show = true
      this.selected_client = client;
    },
    showRejectModal(contract) {
      this.client_cancel_contract_modal_show = true;
      this.selected_contract = contract;
    },
    calcDiscount(hour_value, expected_hour_value) {
      return (100 * (expected_hour_value - hour_value)) / expected_hour_value;
    },
    goToSign(contract) {
      if (contract.vibbrante.able_to_contract) {
        this.$router.push({
          name: 'vibbrant-sign',
          params: { id: contract.id, client_id: contract.client.id },
        });
      } else {
        this.alert_msg =
          'Para assinar contratos como pessoa jurídica, é necessário preencher os dados da sua empresa no seu perfil. Se preferir assinar como pessoa física, deve então preencher no seu perfil todos os seus dados pessoais.';
        this.alert_modal_show = true;
      }
    },
    loadContractBasedOnTab(tab) {
      try {
        const currentTab = tab == 'finalized' ? 'closed' : tab;
        const contractsStatusCapitalized =
          currentTab[0].toUpperCase() + currentTab.slice(1, currentTab.length);
        if (
          this.$store.getters[`vibbrante_${currentTab}_contracts`].length == 0
        )
          this[`load${contractsStatusCapitalized}Contracts`](1);
      } catch (error) {
        console.log('loadContractBasedOnTab error', error);
      }
    },
    clickTabButton(tab) {
      this.loadContractBasedOnTab(tab);
    },
    showTabButton(tab) {
      if (tab === this.activeTab) {
        return 'active active nav-item nav-link';
      }
      return '';
    },
    showTabContent(tab) {
      if (tab === this.activeTab) {
        return 'show active';
      }
      return 'fade';
    },
    loadVibbranteNotification() {
      apiVibbrante
        .vibbranteNotifications()
        .then(response => {
          if (response.status === 200) {
            this.$store.dispatch('loadVibbranteNotifications', response.data);
          }
        })
        .catch(e => {
          this.$notify(e, 'error');
        });
    },
    loadPendingContracts() {
      apiVibbrante
        .loadPendingContracts()
        .then(response => {
          if (response.status === 200) {
            this.$store.dispatch(
              'loadVibbranteWaitingAnswerContracts',
              response.data
            );
            if (
              this.$route.query.openquestion === 'true' &&
              this.$route.query.contract_id !== undefined
            ) {
              let contract = null;
              response.data.forEach(element => {
                if (element.id === parseInt(this.$route.query.contract_id)) {
                  contract = element;
                }
              });
              this.showQuestion(contract);
            }
          }
        })
        .catch(e => {
          this.$notify(e, 'error');
        });
    },
    loadActiveContracts() {
      apiVibbrante
        .loadActivesContracts()
        .then(response => {
          if (response.status === 200) {
            this.$store.dispatch(
              'loadVibbranteActivesContracts',
              response.data
            );
          }
        })
        .catch(e => {
          console.log('loadActiveContracts error >', e);
          this.$notify(e, 'error');
        });
    },
    onPaginationChange(currentPage) {
      this.closedContractsPaginate.currentPage = currentPage;
      this.loadClosedContracts(currentPage);
    },
    loadClosedContracts(currentPage) {
      try {
        this.$store.dispatch('loadVibbranteClosedContracts', []);
        apiVibbrante
          .loadClosedContracts(currentPage)
          .then(response => {
            if (response.status === 200) {
              this.closedContractsPaginate.totalPages =
                response.data.total_pages;
              this.$store.dispatch(
                'loadVibbranteClosedContracts',
                response.data.contracts
              );
            }
          })
          .catch(e => {
            console.log('loadClosedContracts error', e);
            this.$notify(e, 'error');
          });
      } catch (error) {
        console.log('loadClosedContracts error', error);
      }
    },
    loadVibbranteBalances() {
      apiVibbrante
        .vibbranteBalances()
        .then(response => {
          if (response.status === 200) {
            this.$store.dispatch('loadVibbranteBalance', response.data);
          }
        })
        .catch(e => {
          this.$notify(e, 'error');
        });
    },
    closeByReject(contract) {
      apiVibbrante
        .vibbranteCloseByReject(contract.id)
        .then(response => {
          if (response.status === 200) {
            apiVibbrante
              .loadPendingContracts()
              .then(response => {
                if (response.status === 200) {
                  this.$store.dispatch(
                    'loadVibbranteWaitingAnswerContracts',
                    response.data
                  );
                  this.hide();
                }
              })
              .catch(e => {
                this.$notify(e, 'error');
              });
          }
        })
        .catch(e => {
          this.$notify(e, 'error');
        });
    },
    showJustificationModal(contract, text, cancellation_reason) {
      this.selected_contract = contract;
      this.justification_text = text;
      this.cancellation_reason = cancellation_reason;
      this.user_justification_modal_show = true;
    },
    goToTasks(name, contract_id) {
      this.$router.push({
        name: 'vibbrant-client',
        params: { id: contract_id, name },
      });
    },
    showQuestion(contract) {
      this.selected_contract = contract;
      apiVibbrante
        .vibbranteContractComment(contract.id)
        .then(response => {
          apiVibbrante
            .vibbranteContractCommentToRead(contract.id)
            .then(response => {
              apiVibbrante.loadPendingContracts().then(response => {
                if (response.status === 200) {
                  this.$store.dispatch(
                    'loadVibbranteWaitingAnswerContracts',
                    response.data
                  );
                  this.hide();
                }
              });
            });
          if (response.status === 200) {
            this.comments = response.data;
            this.user_question_modal_show = true;
          }
        })
        .catch(e => {
          this.$notify(e, 'error');
        });
    },
    hideAnnouncementModal() {
      this.showAnnouncementModal = false;
    },
    closeUpdateHoursModal() {
      this.showUpdateHoursModal = false;
    },
    saveHours() {
      // First, fetch the complete vibbrante data
      vibbranteApi.getVibbranteData()
        .then(response => {
          // Create a copy of the current vibbrante data
          const vibbranteData = { ...response.data };

          // Update the hour_available and last_time_updated
          vibbranteData.hour_available = this.userAvailableHours;
          vibbranteData.last_time_updated = new Date().toISOString();

          // Update the entire profile with the modified data
          return vibbranteApi.updateProfile(vibbranteData);
        })
        .then(() => {
          this.$notify('Horas atualizadas com sucesso!', 'success');
          this.closeUpdateHoursModal();
        })
        .catch(error => {
          console.error('Error updating hours:', error);
          this.$notify('Erro ao atualizar horas', 'error');
        });
    },
  },
  watch: {
    $route: function(newVal) {
      try {
        const fullPath = newVal.fullPath;
        const currentTab = fullPath.split('/')[fullPath.split('/').length - 1];
        this.loadContractBasedOnTab(currentTab);
      } catch (error) {
        console.log('watch route error', error);
      }
    },
  },
  computed: {
    pendingContracts() {
      return this.$store.getters.vibbrante_pending_contracts;
    },
    activesContracts() {
      return this.$store.getters.vibbrante_active_contracts;
    },
    rejectModalTitle() {
      if (this.selected_contract.client == undefined) {
        return 'Recusar pedido';
      }
      return 'Recusar pedido de ' + this.selected_contract.client.name;
    },
    closedContracts() {
      return this.$store.getters.vibbrante_closed_contracts;
    },
  },
};
</script>

<style scoped>
/* Card de contrato com posição relativa para o ícone */
.contract-card {
  position: relative;
}

/* Badge de contrato renovado */
.renewal-badge {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  background-color: rgba(0, 123, 255, 0.1);
  border: 1px solid #007bff;
  border-radius: 20px;
  padding: 8px 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  margin: 0 auto 12px auto;
  width: fit-content;
  font-size: 12px;
}

.renewal-badge:hover {
  background-color: rgba(0, 123, 255, 0.2);
  transform: scale(1.02);
}

.renewal-text {
  font-size: 11px;
  color: #007bff;
  font-weight: 600;
  white-space: nowrap;
}

.renewal-arrow {
  font-size: 12px;
  display: flex;
  align-items: center;
}

.custom-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.custom-modal {
  background-color: white;
  border-radius: 8px;
  width: 80%;
  max-width: 800px;
  max-height: 90%;
  overflow-y: auto;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  position: relative;
}

.custom-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  border-bottom: 1px solid #e0e0e0;
}

.custom-modal-header h4 {
  margin: 0;
  font-size: 1.25rem;
}

.close-btn {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #666;
}

.custom-modal-body {
  padding: 20px;
}

.form-group {
  margin-bottom: 1rem;
}

.form-control {
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}
</style>

<style lang="scss">
.user-item > .divider {
  display: none;
}
.user-item > .user-item-avatar {
  margin: 0;
}
.avatar {
  position: relative;
  .avatar-remove {
    position: absolute;
    top: 0;
    right: 0;
    line-height: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 26px;
    height: 26px;
    background: rgba(0, 0, 0, 0.5);
    color: white;
    border-radius: 50%;
    font-size: 20px;
    font-family: sans-serif;
  }
}
.user-profile {
  div {
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/parts/pages/vibbrant/clients/clients.vue